import React from 'react';
import { Card, List, Avatar, Tag, Button, Typography } from 'antd';
import { CheckCircleOutlined, RightOutlined } from '@ant-design/icons';

const { Text } = Typography;

const TodoList = ({ todos }) => {
  const getPriorityColor = (priority) => {
    switch(priority) {
      case 'high': return 'red';
      case 'medium': return 'orange';
      case 'low': return 'blue';
      default: return 'default';
    }
  };

  const pendingTodos = todos.filter(todo => todo.status === 'pending').slice(0, 5);

  return (
    <Card 
      title="今日待办" 
      extra={<Button type="link" icon={<RightOutlined />}>查看全部</Button>}
      className="mb-4"
    >
      <List
        dataSource={pendingTodos}
        renderItem={item => (
          <List.Item
            actions={[
              <Tag color={getPriorityColor(item.priority)}>
                {item.priority === 'high' ? '高' : item.priority === 'medium' ? '中' : '低'}
              </Tag>,
              <Text type="secondary">{item.deadline}</Text>
            ]}
          >
            <List.Item.Meta
              avatar={<Avatar icon={<CheckCircleOutlined />} />}
              title={item.title}
              description={`截止日期：${item.deadline}`}
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default TodoList;